import {Dialog} from '~/src/design-system'
import React from 'react'
import styledSC from 'styled-components'
import EulaContent from '~/src/pages/sign-in/EulaContent'
import {useAppSelector} from '~/src/store/store-hooks'
import {Button} from '~/src/design-system/Primitives'

const HeaderText = styledSC.h2`
  font-size: var(--fs-h2);
  line-height: 32px;
  font-weight: var(--fw-bold);
  padding-right: var(--space-5);
  white-space: nowrap;
  margin: 0;
`

const NameAndDate = styledSC.p`
  font-size: var(--fs-subtitle);
  line-height: 32px;
  font-weight: var(--fw-bold);
  color: var(--brand-cta);
  margin: 0;
`

const DialogContent = styledSC.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-10);
`

const DialogHeader = styledSC.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: var(--space-6);
  margin-bottom: var(--space-10);
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-bottom: var(--border-thin) solid var(--neutral-400);
`

const DialogFooter = styledSC.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  gap: var(--space-4);
  padding-top: var(--space-10);
`

interface IProps {
  onModalClose(): void
  isModalOpen: boolean
}

export default function EulaDialog({onModalClose, isModalOpen}: IProps): JSX.Element {
  const {currentUser} = useAppSelector((state) => state.root)
  const agreedToTermsDate = new Date(currentUser?.agreedToTermsDate as unknown as Date)
  const localTime = agreedToTermsDate.toLocaleDateString()

  function handleModalClose() {
    onModalClose()
  }

  return (
    <Dialog
      fullWidth
      fullWidthPaper
      open={isModalOpen}
      onClose={handleModalClose}
      data-testid="eula-dialog"
      PaperProps={{sx: {height: '100%'}}}>
      <DialogContent data-testid="eula-dialog-content">
        <DialogHeader>
          <HeaderText data-testid="eula-dialog-header">Terms & Conditions</HeaderText>
          <NameAndDate>
            {currentUser?.firstName} {currentUser?.lastName} has agreed to these terms on{' '}
            {localTime}
          </NameAndDate>
        </DialogHeader>

        <div
          data-testid="eula-dialog-scroll-content"
          style={{
            width: '100%',
            border: '1px solid grey',
            overflowY: 'scroll',
            flex: '1 1 auto',
            minHeight: 0,
            borderRadius: '4px',
            padding: '25px',
          }}>
          <EulaContent />
        </div>

        <DialogFooter>
          <Button
            variant="secondary"
            type="reset"
            data-testid="eula-dialog-close-button"
            style={{minWidth: 120}}
            onClick={handleModalClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
